import * as React from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Keyboard,
  View,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { backendUrl } from "../constants/Environment.js";
import { ScrollView } from "react-native-gesture-handler";
import { FontAwesome } from "@expo/vector-icons";
import { v4 as uuidv4 } from "uuid";
import * as SecureStore from "expo-secure-store";
import { loginUser, useAuthDispatch } from "../context/Index.js";
import NavbarDesktop from "../components/NavbarDesktop.js";
import { MonoText } from "../components/StyledText.js";

async function handleSignIn(data) {
  if (data.error) {
    console.log("Got an error: " + data.error);
    return;
  }
  var isMobile = await SecureStore.isAvailableAsync();
  if (isMobile) {
    const credentials = {
      id: data.id,
      authToken: data.token,
      deviceId: data.deviceId,
      username: data.username,
      timestamp: data.timestamp,
    };
    try {
      await SecureStore.setItemAsync(
        "authentication_data",
        JSON.stringify(credentials)
      );
      props.history.push("/dashboard");
    } catch (e) {
      console.log(e);
    }
  }
}

export default function LoginScreen({
  setLoggedIn,
  setAuthToken,
  showNavBar,
  navigation: { goBack, navigate, setParams },
}) {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const [statusText, setStatusText] = React.useState("");

  const window = useWindowDimensions();
  const dispatch = useAuthDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();

    var isMobile = await SecureStore.isAvailableAsync();
    let deviceId = isMobile ? "must change" : uuidv4();

    if (!username || !password) {
      setStatusText("Please enter your details");
      return;
    }

    try {
      let response = await loginUser(dispatch, {
        email: username,
        password,
        deviceId: deviceId,
      });
      if (!response || !response.username) {
        setStatusText("Invalid username/password combination");
        return;
      }
      setAuthToken(response.token);
      handleSignIn(response);
      setLoggedIn(true);
      navigate("ArticleList");
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = (values) => {
    handleLogin(values);
  };

  var styleDynamic = StyleSheet.create({
    container: {
      textShadowColor: "#585858",
      textShadowOffset: { width: 5, height: 5 },
      textShadowRadius: 10,
      alignItems: window.width > 900 ? "center" : "stretch",
      marginTop: 10,
      marginBottom: 0,
    },
    nextContainer: {
      marginBottom: 32,
      marginTop: 0,
      alignItems: window.width > 900 ? "center" : "stretch",
      flex: 1,
      paddingTop: 30,
      flexGrow: 1,
    },
  });
  return (
    <ScrollView
      style={{
        backgroundColor: "#fff",
      }}
    >
      {showNavBar ? (
        <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
          <NavbarDesktop
            goBack={goBack}
            navigate={navigate}
            setParams={setParams}
          />
        </View>
      ) : (
        <></>
      )}
      <TouchableOpacity style={styleDynamic.container} activeOpacity={1}>
        <View style={styleDynamic.nextContainer}>
          <KeyboardAvoidingView
            behavior={Platform.OS == "ios" ? "padding" : "height"}
            style={styles.container}
          >
            {/* <TouchableWithoutFeedback onPress={Keyboard.dismiss}> */}
            <TouchableWithoutFeedback >
              <ScrollView
                style={styles.container}
                contentContainerStyle={styles.contentContainer}
              >
                <View style={styles.inner}>
                  <Image
                    source={require("../assets/images/robot-dev.png")}
                    style={styles.welcomeImage}
                  />
                  <Text style={styles.header}>Delta News Login</Text>
                  <View>
                    <TextInput
                      autofocus
                      key="username_key_1"
                      placeholder="Username"
                      name="username"
                      onChangeText={(a) => {
                        setStatusText("");
                        setUsername(a);
                      }}
                      placeholderColor="#c4c3cb"
                      style={styles.textInput}
                    />
                    <TextInput
                      key="password_key_1"
                      placeholder="Password"
                      name="password"
                      placeholderColor="#c4c3cb"
                      style={styles.textInput}
                      secureTextEntry={true}
                      onChangeText={(value) => {
                        setStatusText("");
                        setPassword(value);
                      }}
                    />
                    {statusText !== "" && (
                      <View style={{ marginTop: 24 }}>
                        <MonoText style={{ color: "red" }}>
                          {statusText}
                        </MonoText>
                      </View>
                    )}
                    <View style={{ marginTop: 24 }}>
                      <FontAwesome.Button
                        onPress={(a) => onSubmit(a)}
                        style={styles.loginButtonStyle}
                        backgroundColor="#04d8db"
                        fontSize="2x"
                      >
                        <Text style={{ color: "#fff" }}>LOG IN</Text>
                      </FontAwesome.Button>
                    </View>
                    <View style={{ marginTop: 24 }}>
                      <FontAwesome.Button
                        onPress={() => {
                          Linking.openURL(backendUrl + "/google").catch((err) =>
                            console.error("Couldn't load page", err)
                          );
                        }}
                        style={styles.loginButtonStyle}
                        name="google"
                        backgroundColor="#dc4e41"
                        fontSize="2x"
                      >
                        <Text style={{ color: "#fff" }}>
                          {" "}
                          Sign in with Google
                        </Text>
                      </FontAwesome.Button>
                    </View>
                    <View style={{ marginTop: 24 }}>
                      <FontAwesome.Button
                        onPress={() => {
                          Linking.openURL(backendUrl + "/apple/login").catch(
                            (err) => console.error("Couldn't load page", err)
                          );
                        }}
                        style={styles.loginButtonStyle}
                        name="apple"
                        backgroundColor="#000"
                        fontSize="2x"
                      >
                        <Text style={{ color: "#fff" }}>
                          {" "}
                          Sign in with Apple
                        </Text>
                      </FontAwesome.Button>
                    </View>

                    <View style={styles.textAlreadyHasAccount}>
                      <Text>
                        Not a member?{" "}
                        <Text
                          style={{ color: "blue" }}
                          onPress={() => navigate("Register")}
                        >
                          Register now!
                        </Text>
                      </Text>

                      <Text
                        style={{ color: "blue" }}
                        onPress={() => navigate("ForgotPassword")}
                      >
                        Forgot password?
                      </Text>
                    </View>
                  </View>
                </View>
              </ScrollView>
            </TouchableWithoutFeedback>
          </KeyboardAvoidingView>
        </View>
      </TouchableOpacity>
    </ScrollView>
  );
}

LoginScreen.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingTop: 30,
  },
  welcomeImage: {
    width: 100,
    height: 80,
    resizeMode: "contain",
    marginTop: 3,
    marginLeft: -10,
  },
  loginButtonStyle: {
    color: "#fff",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  textAlreadyHasAccount: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingTop: 16,
  },
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  inner: {
    padding: 24,
    flex: 1,
    justifyContent: "space-around",
  },
  header: {
    fontSize: 36,
    marginBottom: 48,
  },
  textInput: {
    height: 40,
    borderColor: "#000000",
    borderBottomWidth: 1,
    marginBottom: 36,
  },
});
